import {FC} from 'react';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {components} from '../components';
import {theme} from '../constants';

export const NewPassword: FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderHeader = () => {
    return <components.Header goBack={true} />;
  };

  const renderContent = () => {
    return (
        <div style={{ 
              textAlign: 'center', 
              fontSize: '24px',
               fontWeight: 'bold',
                color: theme.colors.mainColor,
                          margin: '0 0 18px 20px',
                          letterSpacing: 1,
                          ...theme.fonts.Mulish_700Bold,}}
              ><h2>Reset Password</h2>
      <div style={{padding: '20px 10px 10px 10px'}}>
        <p
          style={{
            margin: 0,
            marginBottom: 40,
            fontSize: 14,
            color: theme.colors.textColor,
          }}
        >
          Enter new password and confirm.
        </p>
        <custom.InputField
          clickable={true}
          label='password'
          placeholder='••••••••'
          type='password'
          icon={<svg.EyeOffSvg />}
          containerStyle={{marginBottom: 20}}
        />
        <custom.InputField
          clickable={true}
          type='password'
          label='confirm password'
          placeholder='••••••••'
          icon={<svg.EyeOffSvg />}
          containerStyle={{marginBottom: 20}}
        />
        <components.Button
          title='change password'
          onClick={() => {
            navigate('/ForgotPasswordSentEmail');
          }}
        />
      </div>
      </div>
    );
  };
    const renderBottomTabBar = () => {
    return <components.BottomTabBar />;
  };
  return (
    <>
      {renderHeader()}
      {renderContent()}
      {renderBottomTabBar()}
    </>
  );
};
